import { useState } from 'react';

export interface AssistantState {
  userType: 'particulier' | 'professionnel' | 'collectivite' | null;
  selectedOffers?: any[];
  dateEvenement?: string;
  dateAlternative?: string;
  lieuReserve?: boolean;
  adresseLieu?: {
    rue: string;
    codePostal: string;
    ville: string;
    typeLieu: string;
  };
  nombreInvites?: number;
  nombreParticipants?: number;
  budgetIndicatif?: number;
  /** Libellé de la fourchette de budget choisie (ex. « 5 000 € – 10 000 € ») */
  budgetFourchette?: string;
  typeEvenement?: string;
  contraintesLogistiques?: string;
  objectif?: string;
  coordonnees?: {
    nom: string;
    prenom: string;
    telephone: string;
    email: string;
    preferenceContact: 'email' | 'telephone' | 'whatsapp';
    rgpdAccepted: boolean;
  };
}

export const useAssistantState = () => {
  const [state, setState] = useState<AssistantState>({
    userType: null,
  });

  const updateState = (newData: Partial<AssistantState>) => {
    setState(prev => ({ ...prev, ...newData }));
  };

  const resetState = () => {
    setState({ userType: null });
  };

  return {
    state,
    updateState,
    resetState,
  };
};